import { FeatureFlagTypes } from '@generated/graphql';
import { useOrganizationFeatureFlags } from '@ovComponents/4-module/featureFlag/featureFlag';

/**
 * Whether this organization has drift settings at all, for the start-run copy
 * and the link to them.
 *
 * It deliberately reports no percentage. A run covers whatever the engine
 * flagged, and the engine screens each report against the HOLDER
 * organization's policy — which a per-model override can change per portfolio,
 * and which is not the viewing organization's default when a parent-org
 * advisor starts the run. This hook used to fetch that default, fall back to a
 * hardcoded 10, and render the result as "your org's N% drift tolerance": a
 * single number standing in for a policy that is neither single nor
 * necessarily this org's.
 */
export const useBulkRebalanceDriftContext = () => {
  const { isFeatureFlagEnabled } = useOrganizationFeatureFlags();

  // Either flag puts an organization on the tolerance tier — a stored
  // tolerance goes live under B alone. Reading A by itself told an [A off,
  // B on] org it had no drift settings while the engine was screening on
  // theirs.
  const isDriftFeatureEnabled =
    isFeatureFlagEnabled(FeatureFlagTypes.DriftToleranceEnabled) ||
    isFeatureFlagEnabled(FeatureFlagTypes.DriftCalculationMethodEnabled);

  return { isDriftFeatureEnabled };
};
